import Divider from "antd/es/divider";
import React from "react";
import styled from "styled-components";
import Flex from "common/Boxes/Flex";
import { useConfigurationItem } from "features/configuration/GeneralConfiguration/ConfigurationItem";
import FormItem from "features/configuration/GeneralConfiguration/FormItem/FormItem";
import { FormFieldTitle } from "features/tradingTerminal/common/styles";
import { hexToRGB } from "@shared/utils/misc";
import { TRAILING_PERCENT_ITEM_NAME } from "@shared/features/configuration/constants";
import { TwoSelectorsFormItemProps } from "@shared/features/tradingTerminal/common/types";

const TwoSelectorsFormItem = ({
  item,
  hideTitle,
}: TwoSelectorsFormItemProps) => {
  const { itemName, itemChildren, itemShouldDisplay } = useConfigurationItem({
    item,
    valueParser: undefined,
  });

  const childItemData =
    itemChildren.length > 0 && !!itemChildren[1]
      ? useConfigurationItem({
          item: itemChildren[1],
          valueParser: undefined,
        })
      : undefined;

  const hideRelatedSelector =
    childItemData?.itemName === TRAILING_PERCENT_ITEM_NAME &&
    !childItemData?.itemShouldDisplay;

  return (
    <>
      {!hideTitle && (
        <FormFieldTitle $disabled={!itemShouldDisplay}>
          {itemName}
        </FormFieldTitle>
      )}
      <Wrapper $disabled={!itemShouldDisplay}>
        <div style={{ width: hideRelatedSelector ? "100%" : "60%" }}>
          <FormItem
            item={itemChildren?.[0]}
            hideBorder={true}
            hideTitle={true}
            style={{ margin: 0 }}
            disabled={!itemShouldDisplay}
          />
        </div>
        {!hideRelatedSelector && (
          <>
            <VerticalDivider />
            <div style={{ width: "40%" }}>
              <FormItem
                item={itemChildren?.[1]}
                hideBorder={true}
                hideTitle={true}
                style={{ margin: 0 }}
                disabled={!itemShouldDisplay}
              />
            </div>
          </>
        )}
      </Wrapper>
    </>
  );
};

export default TwoSelectorsFormItem;

const Wrapper = styled(Flex)<{ $disabled?: boolean }>`
  border: ${(p) => p.theme.borders.light};
  border-radius: 6px;
  border-color: ${(p) =>
    p.$disabled
      ? hexToRGB(p.theme.colors.secondaryGrey, 0.1)
      : p.theme.colors.lightBorderGrey};
  background: ${(p) =>
    p.$disabled
      ? hexToRGB(p.theme.colors.cardBgColor, 0.5)
      : p.theme.colors.cardBgColor};
  :hover {
    border-color: ${(p) =>
      p.$disabled
        ? hexToRGB(p.theme.colors.primaryBlue, 0.5)
        : p.theme.colors.primaryBlue};
  }
`;
const VerticalDivider = styled(Divider).attrs({ orientation: "vertical" })`
  border-color: ${(p) => p.theme.colors.lightBorderGrey};
  margin: 0 4px;
  height: 20px;
`;
